import React from 'react';
import { Container, HeadingContainer, Title } from './styled';

export type PageSectionProps = {
  className?: string;
  title?: string;
  more?: React.ReactNode;
  children: React.ReactNode;
};

const PageSection = ({
  className,
  title,
  more,
  children,
}: PageSectionProps) => (
  <Container className={className}>
    {title !== undefined && (
      <HeadingContainer>
        <Title>{title}</Title>
        {more}
      </HeadingContainer>
    )}
    {children}
  </Container>
);

export default PageSection;
